import React from 'react';
import { Layout, Row, Col, Typography, Space } from 'antd';
import { GithubOutlined, TwitterOutlined } from '@ant-design/icons';
import { Link as RouterLink } from 'react-router-dom';
import './Footer.css';

const { Footer: AntFooter } = Layout;
const { Title, Paragraph, Link } = Typography;

const Footer = ({ quickLinks = [] }) => {
  return (
    <AntFooter className="footer" role="contentinfo" aria-label="网站页脚">
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Notolang",
          "description": "打造语言学习的智能笔记库",
          "url": "https://notolang.com",
          "logo": "https://notolang.com/logo.svg",
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "contactType": "customer service",
              "email": "hashcr72@gmail.com",
              "availableLanguage": ["Chinese", "English"]
            },
            {
              "@type": "ContactPoint",
              "contactType": "business",
              "identifier": "yinke77777",
              "contactOption": "WeChat"
            }
          ],
          "sameAs": [
            "https://twitter.com/inkerlingo",
            "https://www.xiaohongshu.com/user/profile/5962f73a5e87e7548d9c194a"
          ],
          "foundingDate": "2024",
          "serviceArea": {
            "@type": "Place",
            "name": "全球"
          }
        })}
      </script>

      <div className="footer-content">
        <Row gutter={[32, 32]} justify="center">
          {quickLinks.length > 0 && (
            <Col xs={24} sm={12} md={8} lg={4} className="footer-section-col">
              <section aria-labelledby="quick-links-heading">
                <Title level={4} id="quick-links-heading">产品</Title>
                <nav aria-label="产品导航" className="footer-link-list">
                  {quickLinks.map((item) => (
                    <RouterLink key={item.to} to={item.to} className="footer-nav-link">
                      {item.label}
                    </RouterLink>
                  ))}
                </nav>
              </section>
            </Col>
          )}
          <Col xs={24} sm={12} md={8} lg={4} className="footer-section-col">
            <section aria-labelledby="about-heading">
              <Title level={4} id="about-heading">关于Notolang</Title>
              <Paragraph>
                打造语言学习的智能笔记库。在这里，您可以轻松构建和管理个人语料库，通过影子跟读和听抄训练，高效提升语言听说能力。让每一份学习材料都成为您语言进步的阶梯。
              </Paragraph>
            </section>
          </Col>
          <Col xs={24} sm={12} md={8} lg={4} className="footer-section-col">
            <section aria-labelledby="support-heading">
              <Title level={4} id="support-heading">问题反馈</Title>
              <address>
                <Paragraph>
                  <strong>邮箱：</strong>
                  <Link href="mailto:hashcr72@gmail.com" aria-label="发送邮件到hashcr72@gmail.com">
                    hashcr72@gmail.com
                  </Link>
                </Paragraph>
                <Paragraph>
                  <strong>微信：</strong>
                  <span aria-label="微信号yinke77777">yinke77777</span>
                </Paragraph>
              </address>
            </section>
          </Col>
          <Col xs={24} sm={12} md={8} lg={4} className="footer-section-col">
            <section aria-labelledby="social-heading">
              <Title level={4} id="social-heading">关注我们</Title>
              <nav aria-label="社交媒体链接">
                <Space size={16} className="social-links" direction="vertical">
                  <Link 
                    href="https://twitter.com/inkerlingo" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label="关注我们的Twitter账号"
                  >
                    <Space>
                      <TwitterOutlined className="social-icon" aria-hidden="true" />
                      <span>X (Twitter)</span>
                    </Space>
                  </Link>
                  <Link 
                    href="https://www.xiaohongshu.com/user/profile/5962f73a5e87e7548d9c194a?xsec_token=YBGSZ7tjyeDkh9QaSHhHvGrdidOugp3NYDxOE_HVbfIxo=&xsec_source=app_share&xhsshare=CopyLink&appuid=5962f73a5e87e7548d9c194a&apptime=1749880390&&share_id=a3f88d447b8d44f0966bd3c6d06dcce2" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    aria-label="关注我们的小红书账号"
                  >
                    <Space>
                      <span className="xiaohongshu-icon" aria-hidden="true">📖</span>
                      <span>小红书</span>
                    </Space>
                  </Link>
                </Space>
              </nav>
            </section>
          </Col>
          <Col xs={24} sm={12} md={8} lg={4} className="footer-section-col">
            <section aria-labelledby="business-heading">
              <Title level={4} id="business-heading">商业合作</Title>
              <address>
                <Paragraph>
                  <strong>微信：</strong>
                  <span aria-label="微信号yinke77777">yinke77777</span>
                </Paragraph>
              </address>
            </section>
          </Col>
        </Row>
      </div>

      <footer className="footer-bottom" role="contentinfo">
        <Row>
          <Col span={24}>
            <div className="footer-bottom-content">
              <Space size={16} direction="vertical" align="center">
                <Space size={16} wrap>
                  <Paragraph style={{ marginBottom: 0 }}>
                    © 2026 Notolang. 保留所有权利。
                  </Paragraph>
                </Space>
              </Space>
            </div>
          </Col>
        </Row>
      </footer>
    </AntFooter>
  );
};

export default Footer;
